// language=GraphQL
export const ALL_LABELS_QUERY = `query Query {
  labels: travelLabels {
    id
    label
  }
}`

// language=GraphQL
export const SINGLE_LABEL_QUERY = `query Query($id: ID!) {
  label: travelLabel(id: $id) {
    id
    label
  }
}`

// language=GraphQL
export const CREATE_LABEL_MUTATION = `
  mutation Mutation($input: CreateTravelLabelInput) {
    label: createTravelLabel(input: $input) {
      id
      label
    }
  }`

// language=GraphQL
export const UPDATE_LABEL_MUTATION = `
  mutation Mutation($input: UpdateTravelLabelInput) {
    label: updateTravelLabel(input: $input) {
      id
      label
    }
  }`

// language=GraphQL
export const DELETE_LABEL_MUTATION = `
  mutation Mutation($input: DeleteTravelLabelInput) {
    deleteTravelLabel(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_LABEL_MUTATION = `
  mutation Mutation($input: DeleteTravelLabelInput) {
    forceDeleteTravelLabel(input: $input) {
      success
    }
  }`
// language=GraphQL
export const LABELS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelLabelDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
  }
}`
